export default __webpack_public_path__ + "static/DMMono-Regular-1178fa45ad02216d66ff6c79758d9dbd.woff2";